import { useRef } from "react";
import type { GroupImperativeHandle } from "react-resizable-panels";

export const useResizablePanels = (storageKey: string) => {
	const groupRef = useRef<GroupImperativeHandle>(null);

	const getSavedPanelLayout = (): { table: number; details: number } => {
		try {
			const saved = localStorage.getItem(storageKey);
			if (saved) {
				const layout = JSON.parse(saved);
				if (layout && typeof layout === "object") {
					return layout as { table: number; details: number };
				}
			}
		} catch (e) {
			console.error("Error loading panel layout:", e);
		}
		return { table: 50, details: 50 };
	};

	const handlePanelResize = (layout: { [id: string]: number }) => {
		try {
			localStorage.setItem(storageKey, JSON.stringify(layout));
		} catch (e) {
			console.error("Error saving panel layout:", e);
		}
	};

	const resetPanelLayout = () => {
		if (groupRef.current) {
			const defaultLayout = { table: 50, details: 50 };
			groupRef.current.setLayout(defaultLayout);
			try {
				localStorage.setItem(storageKey, JSON.stringify(defaultLayout));
			} catch (e) {
				console.error("Error saving default layout:", e);
			}
		}
	};

	const handleSeparatorDoubleClick = () => {
		resetPanelLayout();
	};

	return {
		groupRef,
		getSavedPanelLayout,
		handlePanelResize,
		handleSeparatorDoubleClick,
	};
};
